import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { rydeColors, ScreenDepth } from "@ryde/theme";

export const ViewDropdownLabelContainer = styled.span.attrs<IStyledAttributes>({
  "data-e2e": "view-dropdown-label-container",
})`
  display: block;
  max-width: calc(100% - 40px);
`;
export const ViewDropdownIconsContainer = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "view-dropdown-icons-container",
})`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 4px;
  color: ${rydeColors.grey};
`;

export const ViewOptionContainer = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "view-dropdown-option-container",
})`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 16px;
`;

export const ViewDropdownOptionStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "view-dropdown-hover-wrapper",
})`
  width: 100%;

  .ViewDropdownOption-Option {
    cursor: pointer;
  }
  &.ViewDropdownOption_Active > .ViewDropdownOption-Option {
    color: ${rydeColors.purpleTitle};
    background-color: ${rydeColors.viewOptionHover};
  }

  &.ViewDropdownOption_Default {
    .ViewDropdownOption-IconWrapper_Scope {
      color: ${rydeColors.purpleTitle};
    }
  }
  .ViewDropdownOption-IconWrapper {
    display: flex;
    width: 20px;

    > span {
      height: 100%;
      display: inline-flex !important; // Framer tooltip wrapper
      align-items: center;
      justify-content: center;
      width: 100%;
    }
    .MuiIconButton-root {
      padding: 3px;
      width: 100%;

      &:hover {
        color: ${rydeColors.purpleTitle};
      }
    }
    svg {
      display: inline-block;
      height: 14px;
      width: auto;
      transition: color 200ms ease-in-out;
    }
  }
  .ViewDropdownOption-IconWrapper_EditView,
  .ViewDropdownOption-IconWrapper_Delete,
  .ViewDropdownOption-IconWrapper_Update {
    visibility: hidden;
  }
  &:hover {
    .ViewDropdownOption-IconWrapper_EditView,
    .ViewDropdownOption-IconWrapper_Delete,
    .ViewDropdownOption-IconWrapper_Update {
      visibility: visible;
    }
  }
  .ViewDropdownOption-IconWrapper_Delete {
    svg {
      height: 16px;
    }
  }
  .ViewDropdownOption-IconWrapper_Update {
    svg {
      transform: translateY(1px);
    }
  }

  .ViewDropdownOption-ResetButton {
    width: 100%;
  }
`;

export const ViewDropdownWrapperStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "view-dropdown-wrapper",
})`
  .dropdown_blanket {
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    height: 100dvh;
    width: 100vw;
    position: fixed;
    z-index: ${ScreenDepth.MAIN_CONTAINER};
  }
`;
